module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wolterstorff_The_God_We_Worship_text_CC3#toc2"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTOCAnchor-2"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("In the fall of 2013 I delivered the Kantzer Lectures in Revealed Theology at Trinity Evangelical Divinity School in Deerfield, Illinois. This essay is a revision of the text of those lectures. I thank Trinity for the honor of being invited to give the lectures, for the extraordinary hospitality I enjoyed while I was on the campus, and for the astute and helpful comments that students and professors made in the question period after each lecture. I also thank a group of students at the University of Virginia, organized by Matthew Puffer, for reading and offering me helpful comments on an early draft of the lectures; and Terence Cuneo, for likewise reading and commenting on a version of these lectures.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenPageitem-1 _idGenObjectStyleOverride-1"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e98706a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wolterstorff_The_God_We_Worship_text_CC-6.vue
// module id = 72
// module chunks = 0